import { makeStyles } from '@material-ui/core'
import React from 'react'
import Alert from '../../../../../atoms/Alert'
import { useAgentPanelContext } from '../AgentPanelContext'
import ChatMessages from './ChatMessages'
import MessageInput from './MessageInput'

const useStyles = makeStyles(() => ({
  chatPanel: {
    background: 'linear-gradient(var(--color-ai-050), var(--color-ai-100))',
    border: '2px solid var(--color-ai-400)'
  }
}))

function ChatPanel () {
  const classes = useStyles()
  const { addMessage, agentStatus, isErrored, config, versionSaveStatus } = useAgentPanelContext()

  const isProcessing = agentStatus === 'processing'

  return (
    <div className={`${classes.chatPanel} relative h-full flex flex-col radius-xl shadow-lg`}>
      <ChatMessages />
      <div className='w-full'>
        {isErrored && (
          <div className='px-4 py-2'>
            <Alert variant='filled' severity='error'>
              <span className='font-size-xs'>There was an error processing your request.</span>
            </Alert>
          </div>
        )}
        {versionSaveStatus === 'saved' && (
          <div className='py-2 px-3 font-size-xs'>
            <Alert variant='filled' severity='success'>
              <span className='font-size-xs'>Version saved successfully</span>
            </Alert>
          </div>
        )}
        {versionSaveStatus === 'error' && (
          <div className='py-2 px-3 font-size-xs'>
            <Alert variant='filled' severity='error'>
              <span className='font-size-xs'>Failed to save version</span>
            </Alert>
          </div>
        )}
        <div className='relative w-full p-xs'>
          <MessageInput
            placeholder={config.placeholder}
            onSend={addMessage}
            disabled={isProcessing}
          />
        </div>
      </div>
    </div>
  )
}

export default ChatPanel
